import store from "../store";
import axios from "axios";

class Messages {

	// test_jwt (optionnel) : jwt d'un utilisateur simul\u00e9 (\"tester en tant que\"), pour
	// pr\u00e9visualiser les notifications de cet utilisateur - jamais utilis\u00e9 par delete().
	async list(type = "message", test_jwt = null)
	{
		let jwt = test_jwt || store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/message", {
					params: {type},
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					resolve({});
				});
		});
	}
	async get(uid)
	{
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/message/" + uid, {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data.message);
				})
				.catch(function (error) {
					resolve(null);
				});
		});
	}
	async getUsers()
	{
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/message/users", {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data.users);
				})
				.catch(function (error) {
					resolve(null);
				});
		});
	}
	async getUnseenNb(type = "message")
	{
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/message/unseen_nb", {
					params: {type},
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					//console.log(response.data)
					resolve(response.data.unseen);
				})
				.catch(function (error) {
					resolve(null);
				});
		});
	}

	async seen(uid)
	{
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/message/seen/" + uid, {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data.message);
				})
				.catch(function (error) {
					resolve(null);
				});
		});
	}

	async delete(uid)
	{
		let jwt = store.state.jwt;

		console.log('delete : ' + uid)

		return new Promise(function (resolve, reject) {
			axios
				.delete(`${process.env.VUE_APP_SAAS_BACK}` + "/message/" + uid, {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data.notification);
				})
				.catch(function (error) {
					resolve(null);
				});
		});
	}

	async post(title, dest, data, type = "message") {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/message",
					{
						title,
						dest,
						data,
						type
                    },
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
                });
            });
	}
}

export default new Messages();
